module.exports = __webpack_public_path__ + "3d47ef12dfb26b0a67d4f46592f7d439.png";